module.exports = __webpack_public_path__ + "img/trash-can-clock.da158840.svg";